<template>
  <div>
    <Mainlayout></Mainlayout>
    <div class="c-app flex-row align-items-center">
      <CContainer style="display: flex; justify-content: center" class="p-0">
        <div class="container-box center">
          <div class="text-center">
            <img
              style="max-height: 300px"
              src="../assets/img/icon/onlineexam.png"
            />
            <h1 class="title-quiz ml-2 mr-2">{{ quiz.title }}</h1>
          </div>

          <div v-if="$route.query.userId !== undefined">
            <CCol sm="12" class="ml-3 mr-3 mt-3">
              <label>Plese enter your detail</label>

              <div class="text-left">
                <CRow>
                  <span class="width:20%">
                    <img src="../assets/img/icon/book.svg" />
                  </span>
                  <span class="width:80%">
                    <span class="header-title-info ml-2">Name</span>
                    <br /><br />
                  </span>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <CInput
                      type="text"
                      v-model="user.Name"
                      style="max-width: 100% !important"
                      placeholder="Enter your name"
                    />
                  </CCol>
                </CRow>
              </div>
            </CCol>

            <CCol sm="12" class="ml-3 mr-3 mt-3">
              <div class="text-left">
                <CRow>
                  <span class="width:20%">
                    <img src="../assets/img/icon/book.svg" />
                  </span>
                  <span class="width:80%">
                    <span class="header-title-info ml-2">Email</span>
                    <br /><br />
                  </span>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <CInput
                      type="text"
                      v-model="user.Email"
                      style="max-width: 100% !important"
                      placeholder="Enter your email"
                    />
                  </CCol>
                </CRow>
              </div>
            </CCol>
            <CCol sm="12" class="ml-3 mr-3 mt-3">
              <div class="text-left">
                <CRow>
                  <span class="width:20%">
                    <img src="../assets/img/icon/book.svg" />
                  </span>
                  <span class="width:80%">
                    <span class="header-title-info ml-2">Phone</span>
                    <br /><br />
                  </span>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <CInput
                      type="text"
                      v-model="user.PhoneNumber"
                      placeholder="Enter your phone"
                    />
                  </CCol>
                </CRow>
              </div>
            </CCol>
          </div>
          <div v-else>
            <CCol sm="12" class="ml-3 mr-3 mt-3">
              <label>Plese enter your detail</label>

              <div class="text-left">
                <CRow>
                  <span class="width:20%">
                    <img src="../assets/img/icon/book.svg" />
                  </span>
                  <span class="width:80%">
                    <span class="header-title-info ml-2">Name</span>
                    <br /><br />
                  </span>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <CInput
                      type="text"
                      v-model="Name"
                      style="max-width: 100% !important"
                      placeholder="Enter your name"
                    />
                  </CCol>
                </CRow>
              </div>
            </CCol>

            <CCol sm="12" class="ml-3 mr-3 mt-3">
              <div class="text-left">
                <CRow>
                  <span class="width:20%">
                    <img src="../assets/img/icon/book.svg" />
                  </span>
                  <span class="width:80%">
                    <span class="header-title-info ml-2">Email</span>
                    <br /><br />
                  </span>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <CInput
                      type="text"
                      v-model="Email"
                      style="max-width: 100% !important"
                      placeholder="Enter your email"
                    />
                  </CCol>
                </CRow>
              </div>
            </CCol>
            <CCol sm="12" class="ml-3 mr-3 mt-3">
              <div class="text-left">
                <CRow>
                  <span class="width:20%">
                    <img src="../assets/img/icon/book.svg" />
                  </span>
                  <span class="width:80%">
                    <span class="header-title-info ml-2">Phone</span>
                    <br /><br />
                  </span>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <CInput
                      type="text"
                      v-model="PhoneNumber"
                      placeholder="Enter your phone"
                    />
                  </CCol>
                </CRow>
              </div>
            </CCol>
          </div>

          <div class="text-center mt-4 mb-5">
            <CButton
              color="info"
              class="btn-select-blue"
              @click="StudentTakeExam"
              >Take Exam</CButton
            >
            <br />
            <label class="mt-3"
              >Prepare to transform your learning experience with our APP! Our
              state-of-the-art A.I. and advanced analytics will amaze you by
              recommending the most effective methods to enhance your
              performance once this feature is available. For a personalized
              learning experience, we recommend installing our app and using the
              same email address here to ensure that your profile is matched
              accurately.</label
            >
          </div>
        </div>
      </CContainer>
    </div>
  </div>
</template>
  
  <script>
import Vue from "vue";
import _ from "lodash";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/TheHeaderExam.vue";

export default {
  components: {
    Mainlayout,
  },
  data: function () {
    return {
      quiz: {},
      user: {},

      studentProfileAuthorize: "",
      SelectedStudent: "",
      childs: [],

      subjects: [],
      grades: [],

      SelectedGrades: "",
      SelectedSubjects: "",

      Name: "",
      Email: "",
      PhoneNumber: "",
    };
  },
  async mounted() {
    this.GetUserDetail();
  },
  methods: {
    GetQuizDetail() {
      this.$API
        .get(this.$QuizPreview + "?quizId=" + this.$route.query.quizId)
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.quiz = response.data;
          }
        });
    },
    GoToInfoQuiz() {
      this.$router.push("AnswerQuizAll?quizId=" + this.$route.query.quizId);
    },

    StudentStartQuiz() {
      const formData = new FormData();
      formData.append("quizId", this.$route.query.quizId);
      formData.append("studentId", "12190");

      return this.$API
        .post(this.$StudentStartQuiz, formData)
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            var startId = response.data;
            this.getNow(this.quiz.d, this.quiz.h, this.quiz.m, this.quiz.s);
            console.log(this.timestamp);
            this.GoToQuiz(startId);
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
          }
        });
    },
    async GetUserDetail() {
      this.$API
        .get(this.$GetStartUserDetail + "?userId=" + this.$route.query.userId)
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.user = response.data;
          }
        });
    },

    StudentTakeExam() {
      if (this.$route.query.userId !== undefined) {
        const formData = new FormData();
        formData.append("Name", this.user.Name);
        formData.append("Email", this.user.Email);
        formData.append("PhoneNumber", this.user.PhoneNumber);
        formData.append("gui", this.$route.query.guidId);

        return this.$API
          .post(this.$StudentSubmitExam, formData)
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              var startId = response.data;
              this.GoToQuiz(startId);
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
            }
          });
      } else {
        const formData = new FormData();
        formData.append("Name", this.Name);
        formData.append("Email", this.Email);
        formData.append("PhoneNumber", this.PhoneNumber);
        formData.append("gui", this.$route.query.guidId);

        return this.$API
          .post(this.$StudentSubmitExam, formData)
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              var startId = response.data;
              this.GoToQuiz(startId);
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
            }
          });
      }
    },
    GetGuiExam(startId) {
      this.$API
        .get(this.$GetGuiExam + "?startId=" + startId)
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.quiz = response.data;
            this.GoToQuiz(startId, this.quiz);
          }
        });
    },
    GoToQuiz(startId) {
      this.$router.push(
        //   "/QuestionExamBank?subjectId=" +
        //   this.$route.query.subjectId +
        //     "&gradeId=" +
        //     this.$route.query.gradeId +
        //     "&startId=" +
        //     startId

        "/QuestionExamBank?guidId=" +
          this.$route.query.guidId +
          "&startId=" +
          startId
      );
    },
  },
};
</script>
  
  <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

body {
  font-family: "Montserrat", sans-serif;
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: 100vh;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}
</style>